import React from 'react';
import { findCreationCalling } from '../CharacterCustomizer.callings';

interface CallingLorePanelProps {
  callingId: string;
}

export const CallingLorePanel: React.FC<CallingLorePanelProps> = ({ callingId }) => {
  const calling = findCreationCalling(callingId);
  if (!calling) return null;

  return (
    <aside className="cc-calling-lore" aria-label={`${calling.name} calling`}>
      <div className="cc-calling-lore-heading">
        <div>
          <span className="cc-detail-kicker">Your calling</span>
          <div className="cc-calling-name-line">
            <h2>{calling.name}</h2>
            <span>{calling.epithet}</span>
          </div>
        </div>
        <span className="cc-calling-sigil" aria-hidden="true">{calling.icon}</span>
      </div>

      <blockquote className="cc-calling-invocation">{calling.invocation}</blockquote>
      <p className="cc-calling-promise">{calling.promise}</p>

      <div className="cc-calling-discovery">
        <span className="cc-calling-discovery-mark" aria-hidden="true">✦</span>
        <div>
          <span className="cc-detail-kicker">Beyond the threshold</span>
          <p>{calling.discovery}</p>
        </div>
      </div>
    </aside>
  );
};
